import { Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { BehaviorSubject, Observable } from 'rxjs';
import { AuthInfo, LOGIN_MESSAGES } from '../utils/auth.utils';
import { GenericAuthService } from '../utils/generic-auth-service.utils';
import { SessionService } from './session.service';

@Injectable()
export class AdminAppAuthService extends SessionService implements GenericAuthService {
  public loginUrl = `${document.location.origin}/login`;
  public logoutUrl = `${document.location.origin}/logout-success`;

  private _authInfo = new BehaviorSubject<AuthInfo>(AuthInfo.createUnauthenticated());
  public authInfo$ = this._authInfo.asObservable();
  public authInfo: AuthInfo = AuthInfo.createUnauthenticated();

  public loginMessageDict = LOGIN_MESSAGES;

  constructor(private _authService: AuthService) {
    super();
  }

  public trySetRedirectBackUrl(url?: string | undefined): void {
    throw new Error('Method not implemented.');
  }

  public login(): void {
    return;
  }

  public logout(): void {
    this._authService.logout({
      logoutParams: { returnTo: this.logoutUrl },
    });
  }

  public authorize(): void {
    return;
  }

  public getToken(options?: {
    authorizationParams?: {
      scope?: string;
      audience?: string;
    };
  }): Observable<string> {
    return this._authService.getAccessTokenSilently(options);
  }

  public renewTokenIfStale(): void {
    return;
  }

  public renewToken(): void {
    return;
  }

  public popRedirectUrl(): string | null {
    return null;
  }

  public getRedirectUrl(): string | null {
    return null;
  }

  public crossOriginVerification(): void {
    return;
  }

  public resetPasswordRequest(): void {
    return;
  }
  public overrideToken(authInfo: AuthInfo): void {
    return;
  }
}
